import { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { Routes, Route, useParams } from 'react-router-dom';
import xlc_icon from './img/xlc.svg';
import pdf_icon from './img/pdf.svg';
import {
  RangeBoxDoublePeriod,
  DropDownSelector
} from '@lk-gtcom/ecomlab-components';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { Page404 } from '../Page404/Page404';
import './CrossAnalytics.scss';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { useDataTable } from '../../common/hooks';
import { OlegHttps, OlegHttp } from '../../fetchUrls';
import { CrossAnalyticscGeneralIndicators } from '../CrossAnalyticscGeneralIndicators/CrossAnalyticscGeneralIndicators';
import { SideTabs } from '../../components/SideTabs/SideTabs';
import useGeneralStore from '../../store/general';
import { CrossAnalyticsCharts } from './CrossAnalyticsCharts/CrossAnalyticsCharts';
import { TitlePage } from '../../components/TitlePage/TitlePage';
// Отмена запросов для фильтров
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { options_prop_mp } from '../../common/globalVariables';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useResponseHandler } from '../../common/auth';

const btn_tab = [
  { label: 'Графики', value: 'charts' },
  { label: 'Cравнение периодов', value: 'compare_period' },
  { label: 'Cравнение периодов по товарам', value: 'compare_period_by_product' },
  { label: 'Сравнение периодов по категориям', value: 'compare_period_by_category' },
  { label: 'Сравнение периодов по брендам', value: 'compare_period_by_brand' },
  { label: 'Потери от отсутсвия остатков', value: 'absence_of_residues' },
  { label: 'Потери от падения конверсии', value: 'conversion_drop' },
  { label: 'Потери от падения просмотров', value: 'views_drop' },
  { label: 'Потери от подорожания товаров', value: 'price_increases' },
  { label: '20 лучших товаров по доле в выручке за прошлый период и их доля в текущем периоде', value: 'top_20' },
  { label: 'Товары с показами без продаж в сравнении с прошлым периодом', value: 'without_sales' },
  { label: 'Товары с рекламой без продаж', value: 'without_sales_with_adv' },
  { label: 'Причины потерь продаж', value: 'reason_of_lost_profit_pivot' },
];

const periodWeekPrev = () => {
  const now = new Date();
  const endOfDay = new Date(now);
  endOfDay.setDate(endOfDay.getDate() - 7);
  endOfDay.setHours(23, 59, 59, 999);

  const startOfDay = new Date(now);
  startOfDay.setDate(startOfDay.getDate() - 13);
  startOfDay.setHours(0, 0, 0, 0);

  return [startOfDay.getTime(), endOfDay.getTime()];
}

const CrossAnalytics = ({ page = false }) => {
  const apiIdRef = useRef();
  const activeTab = useParams()['*'];
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const requestControllerRef = useRef(new RequestController());

  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const { statusTariff } =
    useGeneralStore(
      useShallow((state) => ({
        statusTariff: state.statusTariff
      }))
    );

  // Навигация 
  const navigate = useNavigate()
  const [isNavigate, setIsNavigate] = useState(false)

  useEffect(() => {
    if (selectedSpace?.value == 4211) {
      if (!isNavigate) {
        setIsNavigate(true)
      } else {
        if (!statusTariff) {
          navigate('/tariff-not-active')
        }
      }
    }
  }, [statusTariff]);

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
  ];

  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMp, setSelectedMp] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [dateCurrent, setDateCurrent] = useState(periodWeek);
  const [datePrevious, setDatePrevious] = useState(periodWeekPrev)

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  // Графики
  const [dataCharts, setDataCharts] = useState([])
  const [loadingCharts, setLoadingCharts] = useState(false)

  useEffect(() => {
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMp(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams]);


  // Таблица 
  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);
    let url = `${OlegHttps}/api/v1/analytics/cross/table/${pageValue}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const [date_from1, date_to1] = dateCurrent;
    const [date_from2, date_to2] = datePrevious;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      mp_id_list: getValueMultiFilter(selectedMp),
      limit: paginatorRef?.current?.limit || 10,
      page: paginatorRef?.current?.page || 1,
      date_from1: new Date(date_from1 + 86401000)
        ?.toISOString()
        ?.split('T')?.[0],
      date_to1: new Date(date_to1)?.toISOString()?.split('T')?.[0],
      date_from2: new Date(date_from2 + 86401000)
        ?.toISOString()
        ?.split('T')?.[0],
      date_to2: new Date(date_to2)?.toISOString()?.split('T')?.[0],
      filters: filtersParam,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Таблица 
  const fetchCharts = (abortController = new AbortController()) => {
    setLoadingCharts(true)
    let url = `https://apps1.ecomru.ru:4450/api/v1/analytics/cross/all/graph`;

    const [date_from1, date_to1] = dateCurrent;
    const [date_from2, date_to2] = datePrevious;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      mp_id_list: getValueMultiFilter(selectedMp),
      date_from1: msToLocalDate(date_from1),
      date_to1: msToLocalDate(date_to1),
      date_from2: msToLocalDate(date_from2),
      date_to2: msToLocalDate(date_to2),
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        if (Array.isArray(json)) {
          setDataCharts(json)
        }
      })
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoadingCharts(false);
      });
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (pageValue !== 'charts') {
      fetchTableData([], abortController);
    } else {
      fetchCharts(abortController)
    }
    return () => abortController.abort();
  }, [
    selectedSpace,
    pageValue,
    dateCurrent,
    datePrevious,
    isTableRequest
  ]);

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      set: setApiData,
      setApiData: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedCategory,
      selectedBrand,
      selectedShop: selectedMp,
      filter: 'api_id'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      selectedApi,
      selectedCategory,
      selectedBrand,
      set: setCategoryData,
      selectedShop: selectedMp,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      page: brandPage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      selectedShop: selectedMp,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      setBrandData: (e) => setBrandData(e),
      set: setBrandData,
      filter: 'brand'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter();
  }, [isFilterRequest, apiPage, apiQuery, selectedSpace]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter();
  }, [isFilterRequest, categoryPage, categoryQuery, selectedSpace]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter();
  }, [isFilterRequest, brandPage, brandQuery, selectedSpace]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const resetTable = () => {
    paginatorRef?.current?.reset();
    paginatorRef?.current?.setTotal(0);
    setSort([]);
    setHeaders([]);
    setTable({});
  };

  useEffect(() => {
    setPageValue(activeTab);
    resetTable();
  }, [activeTab]);

  useEffect(() => {
    setSelectedApi([{ label: 'Все', value: 'all' }]);
    setSelectedCategory([{ label: 'Все', value: 'all' }]);
    setSelectedBrand([{ label: 'Все', value: 'all' }]);
  }, [selectedSpace]);

  const TABLE_TABS = btn_tab
    .filter(({ value }) => value !== 'charts')
    .map(({ value }) => value);

  return (
    <div className="cross-analytics"
      style={{ width: page ? '100%' : '' }}
    >
      <div className="cross-analytics__header">
        <TitlePage
          title='Кросс аналитика'
        />
      </div>

      <FilterContainer
        onReset={(e) => {
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          setIsTableRequest(!isTableRequest)
        }}
      >
        <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMp}
          setState={(e) => setSelectedMp(e)}
          placeholder="Площадка"
          total={options_prop_mp?.length}
          multi
          onBlur={() => {
            updateURL({ mp: selectedMp });
            apiFilter();
            categoryFilter();
            brandFilter();
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Магазин"
          total={totalApi}
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          inputRef={true}
          ref={apiIdRef}
          multi
          onBlur={() => {
            updateURL({ api: selectedApi });
            categoryFilter();
            brandFilter();
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          total={totalCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          multi
          onBlur={() => {
            updateURL({ category: selectedCategory });
            brandFilter();
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          total={totalBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          multi
          onBlur={() => {
            updateURL({ brand: selectedBrand });
            setIsTableRequest(!isTableRequest)
          }}
        />
      </FilterContainer>

      <RangeBoxDoublePeriod
        dateCurrent={dateCurrent}
        datePrevious={datePrevious}
        setDateCurrent={setDateCurrent}
        setDatePrevious={setDatePrevious}
      />

      <div className="flex">
        <div className="cross-analytics__left-content">
          <SideTabs
            title="Содержание отчета"
            //  mp={'general-indicators'}
            pageValue={pageValue}
            setPageValue={(e) => setPageValue(e)}
            tabs={btn_tab}
          />

          <div className="cross-analytics__btn-group">
            <button className="cross-analytics__btn-download">
              <img src={xlc_icon} />
              Скачать в Excel
            </button>
            <button className="cross-analytics__btn-download">
              <img src={pdf_icon} />
              Скачать в PDF
            </button>
          </div>
        </div>

        <div className="cross-analytics__content">
          <Routes>
            <Route path="*" element={<Page404 />} />

            <Route
              path="charts"
              element={<CrossAnalyticsCharts
                dataCharts={dataCharts}
                loadingCharts={loadingCharts}
              />}
            />

            {TABLE_TABS.map((path) => (
              <Route
                key={path}
                path={path}
                element={
                  <CrossAnalyticscGeneralIndicators
                    tableData={{ ...tableProps, tableHeaders: headers }}
                    paginatorRef={paginatorRef}
                    tableCallback={fetchTableData}
                    pageValue={pageValue}
                  />
                }
              />
            ))}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export { CrossAnalytics };
